module.exports = __webpack_public_path__ + "static/media/mail.3918f824.svg";